<template>
  <div class="columns is-multiline">
    <b-table
      v-if="receipts.length > 0"
      :data="filteredReceipts"
      :paginated="true"
      :pagination-simple="false"
      :per-page="15"
      default-sort-direction="'asc'"
      default-sort="bonnummer">
      <template slot-scope="receipt">
        <b-table-column field="bonnummer" label="Bonnummer" sortable>
          {{ receipt.row.bonnummer }}
        </b-table-column>
        <b-table-column field="datum" label="Datum" sortable>
          {{ receipt.row.datum | date }}
        </b-table-column>
        <b-table-column field="debiteur" label="Debiteur" sortable>
          {{ receipt.row.debiteurNumber }}/{{ receipt.row.debiteur }}
        </b-table-column>
        <b-table-column field="crediteur" label="Crediteur" sortable>
          {{ receipt.row.crediteurNumber }}/{{ receipt.row.crediteur }}
        </b-table-column>
        <b-table-column field="ritprijsChauffeur" label="Bedrag chauffeur" sortable>
          {{ receipt.row.ritprijsChauffeur }}
        </b-table-column>
        <b-table-column field="ritprijsFactuur" label="Bedrag klant" sortable>
          {{ receipt.row.ritprijsFactuur }}
        </b-table-column>
        <b-table-column field="kostenplaats" label="Kostenplaats" sortable>
          {{ receipt.row.kostenplaats }}
        </b-table-column>
        <b-table-column label="Bekijken">
          <router-link class="button is-primary" :to="{ name: 'receipts.edit.concept', params: { id: receipt.row.id } }" exact>Bekijken</router-link>
        </b-table-column>
      </template>
    </b-table>

    <div class="column is-5" v-if="receipts.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen bonnen gevonden</p>
        </div>
        <div class="message-body">
          Sla een bon op om gecontroleerd te worden.
        </div>
      </article>
    </div>
  </div>

  <!-- <div class="columns is-multiline">
    <div class="column is-3" v-for="receipt in receipts">


      <div class="columns receipt_footer">
        <div class="column">
          <div class="box-footer">
            <div class="title is-6 spacing-top-10 spacing-bottom-10 no-margin-bottom">
              <h6 class="is-marginless"><b>Nr.</b> {{receipt.bonnummer}}</h6>
              <h6 class="is-marginless"><b>Datum.</b> {{receipt.datum | timezone | date}}</h6>
              <h6 class="is-marginless"><b>Crediteur:</b> {{receipt.crediteur | crediteurNumber}}/{{receipt.crediteur | crediteur}}</h6>
              <h6 class="is-marginless"><b>Debiteur:</b> {{receipt.debiteur | debiteurNumber}}/{{receipt.debiteur | debiteur}}</h6>
              <h6 class="is-marginless"><b>Bedrag chauffeur:</b> €{{receipt.ritprijsChauffeur}}</h6>
              <h6 class="is-marginless"><b>Bedrag klant:</b> €{{receipt.ritprijsFactuur}}</h6>
              <h6 class="is-marginless"><b>Kostenplaats:</b> {{receipt.kostenplaats}}</h6>
            </div>
            <router-link class="button is-primary" :to="{ name: 'receipts.edit.concept', params: { id: receipt.id } }" exact>Bewerken</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-padding-fix column is-5" v-if="receipts.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen bonnen gevonden</p>
        </div>
        <div class="message-body">
          Sla een bon op als concept.
        </div>
      </article>
    </div>
  </div> -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      receipts: 'conceptReceipts'
    }),
    filteredReceipts () {
      return this.receipts.filter(receipt => {
        const search = this.search.toLowerCase()

        if (!search) {
          return true
        }

        if (this.filterGroup.length <= 0) {
          return true
        }

        for (var key in receipt) {
          const isSelected = this.filterGroup.indexOf(key) >= 0
          if (!isSelected) {
            continue
          }

          const value = String(receipt[key]).toLowerCase()

          if (value.includes(search)) {
            return true
          }
        }

        return false
      })
    }
  },
  data () {
    return {
      search: '',
      filterGroup: []
    }
  },
  async created () {
    await this.$store.dispatch('getConceptReceipts', true)
    await this.$store.dispatch('getDebiteuren')
    await this.$store.dispatch('getCrediteuren')

    for (let index in this.receipts) {
      this.receipts[index].crediteurNumber = this.receipts[index].crediteur
      this.receipts[index].debiteurNumber = this.receipts[index].debiteur
      this.receipts[index].crediteur = this.$options.filters.crediteur(this.receipts[index].crediteur)
      this.receipts[index].debiteur = this.$options.filters.debiteur(this.receipts[index].debiteur)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/concept/index.vue